import { querySelectorSafeId } from "utils/helpers"
import { isBrowser } from "utils/infrastructure/ssg-utils"

export function useQuerySelector(
    id: string = querySelectorSafeId()
): [string, () => HTMLElement | null] {
    return [
        id,
        () => {
            if (!isBrowser()) return null
            return document.querySelector(`#${id}`)
        },
    ]
}
